import PasswordInput from './password-input';
import './password-input.scss';

export default PasswordInput;
